import React, { isValidElement } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid2, Icon, IconButton } from '@mui/material'
import { styled } from '@mui/styles'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash'
import { mainBlue } from 'utils/constants/ColorTheme'
import Action from 'components/action/Action'

/**
 * @deprecated use Dialog directly from MUI now
 */
export const DialogMUI = styled(({ PaperProps: { sx, ...othenPaperProps } = {}, ...other }) => (
    <Dialog
        fullWidth
        maxWidth='lg'
        PaperProps={{
            sx: {
                minHeight: '90vh',
                maxHeight: '90vh',
                ...sx,
            },
            ...othenPaperProps,
        }}
        {...other}
    />
))({})

/**
 * @deprecated use DialogTitle directly from MUI now
 */
export const DialogTitleMUI = styled(({ ...other }) => (
    <DialogTitle
        {...other}
    />))(({ theme }) => ({
    backgroundColor: theme.palette.primary.grey,
    color: 'white',
    borderBottom: 'solid 1px grey',
    fontSize: '20px',
    lineHeight: '20px',
}))

/**
 * @deprecated use DialogContent directly from MUI now
 */
export const DialogContentMUI = styled(({ ...other }) => (
    <DialogContent
        {...other}
    />))({
    backgroundColor: '#f0f0f0',
})

/**
 * @deprecated use DialogActions directly from MUI now
 */
export const DialogActionsMUI = styled(({ ...other }) => (
    <DialogActions
        {...other}
    />))({
    borderTop: 'solid 1px grey',
})

const DefaultDialogTitle = ({
    title = '',
    onClose = '',
}) => {
    return (
        <DialogTitle>
            <Grid2 container justifyContent='space-between' alignItems='center'>
                <Grid2 size='grow'>
                    {title}
                </Grid2>
                <Grid2 size='auto'>
                    <IconButton onClick={onClose} sx={{ fontSize: '2rem' }}>
                        <Icon sx={{ color: 'white', fontSize: 'inherit' }}>close</Icon>
                    </IconButton>
                </Grid2>
            </Grid2>
        </DialogTitle>
    )
}

DefaultDialogTitle.propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func,
}

export const DialogActionsTitle = ({
    title = '',
    actions = [],
}) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    return (
        <Grid2 container spacing={2} alignItems='center' sx={{ backgroundColor: mainBlue }} px={2} py={1}>
            <Grid2 size='grow'>
                {isValidElement(title) ? title : (<span style={{ fontSize: '1.4rem', fontWeight: 'bold', color: 'white' }}>{title}</span>)}
            </Grid2>
            {filteredActions.length > 0 && (
                <Grid2 container size='auto' spacing={0.5}>
                    {filteredActions.map(action => (
                        <Grid2 key={actions.indexOf(action)} size='auto'>
                            {isValidElement(action) ? action : (<Action {...action} color='white' />)}
                        </Grid2>
                    ))}
                </Grid2>
            )}
        </Grid2>
    )
}

DialogActionsTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
}

export {
    DefaultDialogTitle,
}